export const name = "ARRAY_CONCAT_AGG";
export const summary = `Concatenates arrays and returns a single array as a result.`;
export const reference = `
## ARRAY_CONCAT_AGG

Concatenates arrays and returns a single array as a result.

\`\`\`
ARRAY_CONCAT_AGG(
  expression
  [ORDER BY key [ { ASC | DESC }] [, ...] ]
  [LIMIT n]
)
\`\`\`

### Description

Concatenates elements from \`expression\` of type \`ARRAY\`, returning a single array as a result.

This function ignores \`NULL\` input arrays, but respects the \`NULL\` elements in non-\`NULL\` input arrays. An error is raised, however, if an array in the final query result contains a\`NULL\` element. Returns \`NULL\` if there are zero input rows or\`expression\` evaluates to \`NULL\` for all rows.

To learn more about the optional aggregate clauses that you can pass into this function, see Aggregate function calls.


### Supported Argument Types

\`ARRAY\`


### Returned Data Types

\`ARRAY\`


### Examples



\`\`\`
SELECT FORMAT("%T", ARRAY_CONCAT_AGG(x)) AS array_concat_agg FROM (
  SELECT [NULL, 1, 2, 3, 4] AS x
  UNION ALL SELECT NULL
  UNION ALL SELECT [5, 6]
  UNION ALL SELECT [7, 8, 9]
);

/*-----------------------------------*
 | array_concat_agg |
 +-----------------------------------+
 | [NULL, 1, 2, 3, 4, 5, 6, 7, 8, 9] |
 *-----------------------------------*/
\`\`\`



\`\`\`
SELECT FORMAT("%T", ARRAY_CONCAT_AGG(x ORDER BY ARRAY_LENGTH(x))) AS array_concat_agg FROM (
  SELECT [1, 2, 3, 4] AS x
  UNION ALL SELECT [5, 6]
  UNION ALL SELECT [7, 8, 9]
);

/*-----------------------------------*
 | array_concat_agg |
 +-----------------------------------+
 | [5, 6, 7, 8, 9, 1, 2, 3, 4] |
 *-----------------------------------*/
\`\`\`



\`\`\`
SELECT FORMAT("%T", ARRAY_CONCAT_AGG(x LIMIT 2)) AS array_concat_agg FROM (
  SELECT [1, 2, 3, 4] AS x
  UNION ALL SELECT [5, 6]
  UNION ALL SELECT [7, 8, 9]
);

/*--------------------------*
 | array_concat_agg |
 +--------------------------+
 | [1, 2, 3, 4, 5, 6] |
 *--------------------------*/
\`\`\`



\`\`\`
SELECT FORMAT("%T", ARRAY_CONCAT_AGG(x ORDER BY ARRAY_LENGTH(x) LIMIT 2)) AS array_concat_agg FROM (
  SELECT [1, 2, 3, 4] AS x
  UNION ALL SELECT [5, 6]
  UNION ALL SELECT [7, 8, 9]
);

/*------------------*
 | array_concat_agg |
 +------------------+
 | [5, 6, 7, 8, 9] |
 *------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
`;
